import React from 'react';
import SouthernLivingCards from '../../components/cards/SouthernLivingCards';
import SouthernLivingHero from '../../components/hero/SouthernLivingHero';
import SouthernLivingTestimonials from '../../components/testimonials/SouthernLivingTestimonials';

const SouthernLivingHome2025 = () => {
  return (
    <main>
      <SouthernLivingHero />
      <SouthernLivingCards />
      <SouthernLivingTestimonials />
    </main>
  );
};

export default SouthernLivingHome2025;
